"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.willComponentRender = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var ramda_1 = require("ramda");
/**
 * Returns boolean value if component will be rendered according to provided conditions
 */
var willComponentRender = function (
/** Object which properties will be validated */
object, conditions, 
/** Additional properties might be given as a third parameter if passed from ProductData. `useBatchPrice`
 *  and `usePackagePrice` will be used to determine if ProductData component will be rendered.
 */
additionalProperties) {
    if (!conditions || !object) {
        return true;
    }
    var item = __assign({}, object);
    if (additionalProperties) {
        item.useBatchPrice = additionalProperties.useBatchPrice;
        item.usePackagePrice = additionalProperties.usePackagePrice;
        item.useBatchPercentage = additionalProperties.useBatchPercentage;
    }
    var condition = conditions.condition, rules = conditions.rules;
    return validateRules(condition, item, rules);
};
exports.willComponentRender = willComponentRender;
/**
 * Validate rules by looping trough the rules array
 * and comparing operators to item property values.
 * @param condition
 * @param item
 * @param rules might be undefined due to a previous bug
 * @TODO change rules back to required after all templates are fixed
 */
var validateRules = function (condition, item, rules) {
    var result = false;
    if (!rules) {
        return true;
    }
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var rule = rules_1[_i];
        var property = rule.property, operator = rule.operator, value = rule.value;
        var propertyPath = property.split('.');
        var propertyValue = (0, ramda_1.path)(propertyPath, item);
        switch (operator) {
            case seesignage_utils_1.ComponentRuleOperator.contains:
                if (typeof propertyValue === 'string' && typeof value === 'string') {
                    result = propertyValue.includes(value);
                }
                break;
            case seesignage_utils_1.ComponentRuleOperator.equals:
                if (propertyValue && value) {
                    result = propertyValue === value;
                }
                break;
            case seesignage_utils_1.ComponentRuleOperator.exists:
                result = propertyValue !== undefined && propertyValue !== null;
                break;
            case seesignage_utils_1.ComponentRuleOperator.greaterThan:
                if (propertyValue && value) {
                    result = propertyValue > value;
                }
                break;
            case seesignage_utils_1.ComponentRuleOperator.lessThan:
                if (propertyValue && value) {
                    result = propertyValue < value;
                }
                break;
            case seesignage_utils_1.ComponentRuleOperator.notContains:
                if (typeof propertyValue === 'string' && typeof value === 'string') {
                    result = !propertyValue.includes(value);
                }
                break;
            case seesignage_utils_1.ComponentRuleOperator.notExists:
                result = !propertyValue;
                break;
            case seesignage_utils_1.ComponentRuleOperator.true:
                result = propertyValue === true;
                break;
            case seesignage_utils_1.ComponentRuleOperator.false:
                result = propertyValue === false || propertyValue === undefined || propertyValue === null;
                break;
            default:
                break;
        }
        // continue looping through rules
        if ((condition === seesignage_utils_1.LogicalOperator.and && result) ||
            (condition === seesignage_utils_1.LogicalOperator.or && !result)) {
            continue;
        }
        else if (condition === seesignage_utils_1.LogicalOperator.and && !result) {
            return false;
        }
        else if (condition === seesignage_utils_1.LogicalOperator.or && result) {
            return true;
        }
    }
    return result;
};
//# sourceMappingURL=conditions.js.map